import { normalizeQuantity, quantityError } from '@krp/sale-ui'

/**
 * Количество возврата: форма — как у корзины продажи (больше 0, до трёх
 * знаков), плюс «не больше остатка позиции». Это подсказка до нажатия; решает
 * служба — её отказ показывается дословно.
 */

/** Меры, у которых количество дробное (вес), — те же коды, что проверяет служба (C2/C4b). */
const WEIGHT_UNIT_CODES: ReadonlySet<number> = new Set([10, 11, 12])

/** Тысячные доли: количество `numeric(18,3)` сравнивается целыми, без накопления ошибки float. */
export function thousandths(value: number): number {
  return Math.round(value * 1000)
}

/** Дробное количество допустимо: весовая мера или продано дробное (служба судит так же). */
export function fractionalAllowed(unitCode: number, soldQuantity: number): boolean {
  return WEIGHT_UNIT_CODES.has(unitCode) || thousandths(soldQuantity) % 1000 !== 0
}

/** Почему количество возврата не годится — словами; `null` — годится. */
export function refundQuantityError(text: string, available: number, fractional: boolean): string | null {
  const form = quantityError(text, fractional)
  if (form !== null) return form
  const wanted = thousandths(Number(normalizeQuantity(text)))
  if (wanted > thousandths(available)) {
    return available <= 0 ? 'Позиция уже возвращена полностью' : 'Больше, чем осталось вернуть по позиции'
  }
  return null
}

/** Число для тела запроса. Строка уже проверена: до трёх знаков, без потерь в JSON. */
export function refundQuantityNumber(text: string): number {
  return Number(normalizeQuantity(text))
}
